var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var mockedAuthStrategy = function (_a) {
    var _b = _a === void 0 ? {
        authenticated: true,
    } : _a, _c = _b.authenticated, authenticated = _c === void 0 ? true : _c, error = _b.error, payload = _b.identity;
    return ({
        get: function () {
            if (error) {
                throw error;
            }
            var identity = __assign({ sub: {
                    ID: 'mocked-user-id',
                } }, payload);
            return Promise.resolve(authenticated
                ? {
                    authenticated: true,
                    tokenHeader: 'Authorization',
                    token: "Bearer mock.".concat(JSON.stringify(identity)),
                    identity: identity,
                }
                : {
                    authenticated: false,
                });
        },
        clear: function () {
        },
    });
};
export var createMockedAuthStrategy = function (_a) {
    var mockOptions = _a.mockOptions;
    return mockedAuthStrategy(mockOptions);
};
export default mockedAuthStrategy;
//# sourceMappingURL=mocked-auth-strategy.js.map